import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineNarrativeDescriptionAndCost from 'utils/print/getOrderLineNarrativeDescriptionAndCost';
import getSignature from 'utils/print/getSignature';

const CMS847 = {
  ID: 5,
  Name: 'CMS-847 Osteogenesis Stimulators',
  Type: 'CMS',
  Format: 'a4',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-847/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 90.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 97.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 104.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 126.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 133.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 140.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 177.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 184.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 191.5,
          y: 33.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 14,
          y: 42,
          width: 95,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 14,
          y: 45.25,
          width: 95,
          height: 13,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 15,
          y: 58.5,
          width: 11,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 28,
          y: 58.5,
          width: 11,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 43,
          y: 58.5,
          width: 15,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 77,
          y: 58.5,
          width: 32,
        },
        {
          name: 'Supplier Name and Address',
          type: 'text',
          getValue: (props) => {
            if (props.value) {
              return props.value;
            }
            return `${getSupplierName(props)}, ${getSupplierFullAddress(props)}`;
          },
          x: 112,
          y: 42,
          width: 84,
          height: 15.3,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 113,
          y: 58.5,
          width: 11,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 126,
          y: 58.5,
          width: 11,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 140,
          y: 58.5,
          width: 15,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 175,
          y: 58.5,
          width: 21,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 38,
          y: 66.5,
          width: 19,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 123.5,
          y: 66.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 130,
          y: 66.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 137,
          y: 66.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 150,
          y: 66.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 170,
          y: 66.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 187,
          y: 66.5,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s)',
          type: 'text',
          getValue: getOrderLineHCPCSCode,
          x: 60,
          y: 73,
          width: 50,
          height: 25.5,
          multiline: true,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 112,
          y: 77,
          width: 84,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 112,
          y: 80.5,
          width: 84,
          height: 13,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 113,
          y: 93,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 126,
          y: 93,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 141,
          y: 93,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 178,
          y: 93,
          width: 18,
        },
        {
          name: 'EST LENGTH OF NEED',
          type: 'text',
          x: 73,
          y: 106.5,
          width: 10,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'DIAGNOSIS CODES',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 145,
          y: 106.5,
          width: 51,
        },
        {
          name: 'In a fracture, has there been no clinically significant radiographic evidence of healing for a minimum of 90 days?',
          type: 'radio',
          options: [
            {
              x: 17.5,
              y: 142,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 24,
              y: 142,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 30.5,
              y: 142,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Does the patient have a failed fusion of a joint other than the spine?',
          type: 'radio',
          options: [
            {
              x: 17.5,
              y: 149,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 24,
              y: 149,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 30.5,
              y: 149,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'How many months prior to ordering the device did the patient have the fusion?',
          type: 'text',
          x: 18,
          y: 153,
          width: 18,
          normalize: normalize.number,
        },
        {
          name: 'Does the patient have a congenital pseudoarthrosis?',
          type: 'radio',
          options: [
            {
              x: 14,
              y: 163,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 20.5,
              y: 163,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 26,
              y: 163,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Is the device being ordered as a treatment of a failed single level spinal fusion surgery in a patient who has not had a recent repeat fusion?',
          type: 'radio',
          options: [
            {
              x: 17,
              y: 170,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 23,
              y: 170,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 29,
              y: 170,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'How many months prior to ordering the device did the patient have the fusion? 2',
          type: 'text',
          x: 17,
          y: 175,
          width: 19,
          normalize: normalize.number,
        },
        {
          name: 'Is the device being ordered as an adjunct to repeat single level spinal fusion surgery in a patient with a previously failed spinal fusion at the same level(s)?',
          type: 'radio',
          options: [
            {
              x: 17.5,
              y: 184,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 24,
              y: 184,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 30.5,
              y: 184,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'How many months prior to ordering the device did the patient have the repeat fusion?',
          type: 'text',
          x: 17,
          y: 188,
          width: 19,
          normalize: normalize.number,
        },
        {
          name: 'How many months prior to ordering the device did the patient have the previously failed fusion?',
          type: 'text',
          x: 17,
          y: 192,
          width: 19,
          normalize: normalize.number,
        },
        {
          name: 'Is the device being ordered following multi¬level spinal fusion surgery?',
          type: 'radio',
          options: [
            {
              x: 15,
              y: 201,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 20.5,
              y: 201,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 27,
              y: 201,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Has there been at least one open surgical intervention for treatment of the fract ure?',
          type: 'radio',
          options: [
            {
              x: 15,
              y: 205.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 20.5,
              y: 205.5,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 27,
              y: 205.5,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'NAME OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 25,
          y: 214,
          width: 59,
        },
        {
          name: 'TITLE OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 95,
          y: 214,
          width: 41,
        },
        {
          name: 'EMPLOYER OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 155,
          y: 214,
          width: 41,
        },
        {
          name: '(1) Narrative description of all items, accessories and option ordered; (2) Suppliers charge; and (3) Medicare Fee Schedule Allowance for each item, accessory, and option',
          type: 'text',
          getValue: getOrderLineNarrativeDescriptionAndCost,
          x: 14,
          y: 236,
          width: 182,
          height: 13,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 55,
          y: 271,
          width: 90,
          height: 7,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 165,
          y: 273,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 175,
          y: 273,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 185,
          y: 273,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS847;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-847.js